export enum LuckySpinsQueryKeys {
  Primary = '/lucky-spins',
}
